<template>
	<div class="add-box">
		<el-dialog v-model="dialogVisible" width="500px" :before-close="handleClose">
			<img :src="facePic" style="max-width: 450px; max-height: 640px;; object-fit:cover;">
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="handleClose">返回</el-button>
					<el-button type="primary" @click="selectFile">替换</el-button>
					<input type="file" style="display: none" ref="fileInput" accept=".png, .jpg, .jpeg"
						@change="handleFileChange">
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {uploadFace} from '@/assets/api/renyuan';
	import { ElMessage,ElLoading } from 'element-plus'
	import {getFace,addFace,updateFace,getBase64FromFilePath} from "@/assets/api/baiduApi"
	export default {
		props: ['titleValue', 'detailsObj'],
		components: {},
		data() {
			return {
				facePic: "",
				studentId: "",
				title: '',
				dialogVisible: true,
			};
		},
		created() {
			this.title = this.titleValue
			this.facePic = this.detailsObj.facePic + `?${this.getTime()}`
			this.studentId = this.detailsObj.studentId
		},
		mounted() {},
		methods: {
			handleClose() {
				this.$emit('addClick')
			},

			selectFile(event) {
				this.$refs.fileInput.click();
			},
			
			getTime(){
				return new Date().getTime();
			},

			handleFileChange(event) {
				const file = event.target.files[0];
				const reader = new FileReader();
				reader.onload = (e) => {
					const dataURL = e.target.result;
					const targetSizeKB = 300; //图片大小限制
					this.compressH5(dataURL, targetSizeKB).then(file => {
						console.log('file 222 = ', file)
						const filePath = new File([file], Date.now() + ".jpeg", {
							type: file.type,
							lastModified: Date.now()
						});
						if (filePath) {
							//同步到百度人脸库
							this.getFace(this.studentId,filePath);
						}
						event.target.value = '';
					}).catch(err => {
						ElMessage.error("图片压缩异常")
					})
				};
				reader.readAsDataURL(file);
			},

			compressH5(base64Str, targetSizeKB) {
				const maxQuality = 1.0;
				const minQuality = 0.0;
				const tolerance = 0.01; // 根据需要调整公差
				return new Promise((resolve, reject) => {
					const binarySearch = (min, max) => {
						const midQuality = (min + max) / 2;
						const img = new Image();
						img.src = base64Str;
						img.onload = function() {
							const canvas = document.createElement('canvas');
							const ctx = canvas.getContext('2d');

							let width = img.width;
							let height = img.height;
							while(width < 480 || width > 720){
								width = width / 4 * 3
								height = height / 4 * 3
							};
							
							canvas.width = Math.floor(width);
							canvas.height = Math.floor(height);

							ctx.clearRect(0, 0, canvas.width, canvas.height);
							ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

							// 使用异步的 toBlob 方法
							canvas.toBlob(async (blob) => {
								const fileSizeKB = blob.size / 1024;
								if (Math.abs(fileSizeKB - targetSizeKB) < tolerance || max -
									min < tolerance) {
									// 当前质量足够接近目标大小，使用当前质量解析
									resolve(blob);
								} else if (fileSizeKB > targetSizeKB) {
									// 如果文件大小太大，降低质量，继续二分查找
									binarySearch(min, midQuality);
								} else {
									// 如果文件大小太小，增加质量，继续二分查找
									binarySearch(midQuality, max);
								}
							}, 'image/jpeg', midQuality);
						};
					};

					// 开始二分查找
					binarySearch(minQuality, maxQuality);
				});
			},
			
			getFace(studentId,filePath){
				const param = {
					"group_id":"students",
					"user_id":studentId
				}
				
				this.openElLoading()
				getFace(param).then(async (res) => {
					if(res.data.error_code === 223103){ //人脸未注册
						const base64 = await getBase64FromFilePath(filePath);
						if(base64 != null){
							this.addFace(filePath,base64,studentId);
						}
					}else if(res.data.error_code === 0){ // 人脸已注册
						const base64 = await getBase64FromFilePath(filePath);
						if(base64 != null){
							this.updateFace(filePath,base64,studentId);
						} 
					}else{
						this.closeElLoading();
						ElMessage.error("人脸解析失败，请更换图片后重试")
					}
				}).catch((err) => {
					this.closeElLoading();
					ElMessage.error("人脸查找失败")
				})
			},
			
			addFace(filePath,image,studentId){
				const param = {
					"group_id":"students",
					"image":image,
					"image_type":"BASE64",
					"user_id":studentId,
				}
				addFace(param).then((res) => {
					if(res.data.error_code === 0){ //注册成功
						this.uploadFace(filePath,studentId)
					}else{
						this.closeElLoading();
						ElMessage.error("人脸注册失败") 
					}
				}).catch((err) => {
					this.closeElLoading();
					ElMessage.error("人脸注册失败")
				})
			},
			
			updateFace(filePath,image,studentId){
				const param = {
					"group_id":"students",
					"image":image,
					"image_type":"BASE64",
					"user_id":studentId,
				}
				updateFace(param).then((res) => {
					if(res.data.error_code === 0){ //更新成功
						this.uploadFace(filePath,studentId)
					}else{
						this.closeElLoading()
					 	ElMessage.error("人脸更新失败") 
					}
				}).catch((err) => {
					this.closeElLoading();
					ElMessage.error("人脸更新失败")
				})
			},
			
			uploadFace(filePath,studentId){
				let formData = new FormData();
				formData.append("file", filePath);
				formData.append("personId ", studentId);
				formData.append("personType", "1");
				formData.append("suffix", "jpeg");
				uploadFace(formData).then((res) => {
					console.log(res);
					this.closeElLoading();
					this.handleClose();
					ElMessage.success("人脸上传成功！")
				}).catch((err) => {
					this.closeElLoading();
					ElMessage.error("上传失败")
				})
			},
			
			openElLoading(){
				this.elLoading = ElLoading.service({
					lock: true,
					text: '图片上传中，请稍候...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			
			closeElLoading(){
				if(this.elLoading){
					this.elLoading.close();
					this.elLoading = null;
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep() {
		.el-dialog__body {
			// height: 75%;
			max-height: 500px;
			// min-height: 350px;        
			overflow: auto;
		}

		// }
		.el-input--small {
			width: 250px;
		}

		.el-select .el-input__inner {
			height: 35px;
			line-height: 35px;
		}

		.el-form-item--small .el-form-item__label {
			height: 35px;
			line-height: 35px;
		}

		.el-input__inner {
			height: 35px;
			line-height: 35px;
		}

		.el-radio.el-radio--small .el-radio__inner {
			width: 14px;
			height: 14px;
		}

		.el-input__wrapper {
			height: 35px;
			line-height: 35px;
		}

		.el-date-editor.el-input,
		.el-date-editor.el-input__wrapper {
			height: 35px !important;
		}

		.el-select--small .el-select__wrapper {
			width: 250px;
			height: 35px;
		}
	}
</style>